import Footer from '@app/components/Footer'
import Navbar from '@app/components/Navbar'
import { useIntl } from 'react-intl'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import S from './styles'

const Privacy = () => {
  const { messages } = useIntl()

  return (
    <>
      <Navbar />
      <S.Main>
        <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw as any]}>
          {messages['privacy_policy_page.content.page_settings.body'] as string}
        </Markdown>
      </S.Main>
      <Footer />
    </>
  )
}

export default Privacy
